import api from 'service/api'

const dponetAPI = api.create('dponet')

const index = async ({ ...params } = {}) => {
  return await dponetAPI.get('/committee_categories', { params })
}

const create = async ({ name }) => {
  return await dponetAPI.post('/committee_categories', {
    committeeCategory: { name },
  })
}

export default {
  index,
  create,
}
